
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Heart, ShoppingCart, User, AlignJustify } from "lucide-react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import CartSidebar from "@/components/CartSidebar";
import LoginModal from "@/components/LoginModal";
import { useAuth } from "@/contexts/AuthContext";
import { useCart } from "@/contexts/CartContext";

const BrandHeader = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const { isAuthenticated, checkToken } = useAuth();
  const { getTotalItems } = useCart();
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleAccountClick = async () => {
    if (isAuthenticated) {
      // Check if token is still valid
      const isValid = await checkToken();
      if (isValid) {
        navigate('/account');
      } else {
        setIsLoginModalOpen(true);
      }
    } else {
      setIsLoginModalOpen(true);
    }
  };

  const handleLoginSuccess = () => {
    navigate('/account');
  };

  return (
    <header className="sticky top-0 z-[9999] w-full border-b bg-primary text-primary-foreground">
      <div className="container mx-auto flex h-16 items-center gap-4 px-4 relative">
        {/* Hamburger Menu */}
        <SidebarTrigger className="flex-shrink-0">
          <AlignJustify className="h-5 w-5" />
        </SidebarTrigger>

        {/* Logo */}
        <Link to="/" className={`flex shrink-0 items-center ${isMobile ? 'absolute left-1/2 transform -translate-x-1/2' : 'flex-1 justify-center'}`}>
          <img
            src="/lovable-uploads/d5b011bc-34ae-449a-8ec6-8e13ea03ceae.png"
            alt="Mon Copieur logo"
            className="h-8 w-auto"
            loading="eager"
          />
        </Link>

        {/* Desktop: Right icons */}
        <div className={`items-center gap-1 ${isMobile ? 'hidden' : 'flex'}`}>
          <Button variant="navicon" size="icon" aria-label="Favoris">
            <Heart className="h-5 w-5" />
          </Button>
          <CartSidebar isOpen={isCartOpen} onOpenChange={setIsCartOpen}>
            <Button variant="navicon" size="icon" aria-label="Panier" className="relative">
              <ShoppingCart className="h-5 w-5" />
              {getTotalItems() > 0 && (
                <span className="absolute -top-1 -right-1 bg-background text-foreground text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">
                  {getTotalItems()}
                </span>
              )}
            </Button>
          </CartSidebar>
          <Button variant="navicon" size="icon" aria-label="Connexion" onClick={handleAccountClick}>
            <User className="h-5 w-5" />
          </Button>
        </div>
      </div>
      
      <LoginModal 
        isOpen={isLoginModalOpen} 
        onOpenChange={setIsLoginModalOpen}
        onSuccess={handleLoginSuccess}
      />
    </header>
  );
};

export default BrandHeader;
